export const googleMetaTags = 
    {
        "@context": "http://schema.org",
        "@type": "AboutPage",
        "about": {
            "@type": "Organization",
            "contactPoint": {
                "@type": "ContactPoint",
                "url": "https://roaminghunger.com",
                "name": "Roaming Hunger Contact Point",
                "email": "hungry@roaminghunger.com",
                "telephone": "+1-800-568-9370",
                "contactType": "Sales",
                "availableLanguage": "en-US",
                "contactOption": "TollFree",
                "@id": "https://roaminghunger.com/#ContactPoint"
            },
            "knowsAbout": [
                "https://www.wikidata.org/wiki/Q6887072",
                "https://www.wikidata.org/wiki/Q3303463"
            ],
            "knowsLanguage": "en-US",
            "url": "https://roaminghunger.com",
            "image": "https://d3hbe0kmbam4a5.cloudfront.net/assets/static/media/homepage-carousel-3.ff88590d.jpg",
            "name": "Roaming Hunger",
            "description": "Find and book your favorite food trucks and food carts with Roaming Hunger, the hub for all things street food and catering. Use the interactive city map to find out where your next meal is parked or book a tasty vendor for your next event.",
            "logo": "https://d3hbe0kmbam4a5.cloudfront.net/assets/static/media/logo-bg.dca95380.svg",
            "email": "hungry@roaminghunger.com",
            "telephone": "+1-800-568-9370",
            "address": {
                "@type": "PostalAddress",
                "streetAddress": "10951 W Pico Blvd, Ste 300",
                "postalCode": "90064",
                "addressRegion": "CA",
                "addressLocality": "Los Angeles",
                "addressCountry": "US",
                "name": "Roaming Hunger Postal Address",
                "url": "https://roaminghunger.com",
                "@id": "https://roaminghunger.com/#PostalAddress"
            },
            "sameAs": [
                "https://en.wikipedia.org/wiki/Roaming_Hunger",
                "https://twitter.com/roaminghunger?lang=en",
                "https://www.facebook.com/roaminghunger/",
                "https://www.bbb.org/us/ca/west-hollywood/profile/food-trucks/roaming-hunger-1216-886904",
                "https://www.secure.instagram.com/roaminghunger/?hl=fb-ha",
                "https://www.yelp.com/biz/roaming-hunger-belmont",
                "https://www.crunchbase.com/organization/roaming-hunger",
                "https://www.linkedin.com/company/roaming-hunger/"
            ],
            "legalName": "Roaming Hunger, LLC ",
            "foundingDate": "2009-08-08T00:00:00+0000",
            "@id": "https://roaminghunger.com"
        },
        "url": "https://roaminghunger.com/pages/about/",
        "description": "We are the culinary community builders who bring together colleagues, friends, family members and strangers through unexpected and joyful moments. Moments like when the aroma of spicy firecracker wings mixes with the lunchtime chatter of colleagues; when an impromptu game of rock, paper, scissors starts up as friends wait for their orders to be called; a wedding dance beneath lights strung between food trucks; a friendly face offering a napkin to keep an ice cream drip from falling. We don’t just bond over food, we share in exceptional experiences.",
        "name": "Roaming Hunger About page",
        "@id": "https://roaminghunger.com/pages/about/#AboutPage"
    }